// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__NsMLP","info":"PatientInfo_info__-T4lt"};